import { call, put, delay } from 'redux-saga/effects';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { loadHistoryListFailed, loadHistoryListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* loadHistoryList(action) {
  try {
    const {
      payload: {
        page = 1,
        limit = DEFAULT_ITEMS_OF_PAGE,
        host_id,
        filter,
      } = {},
    } = action;
    const url = `${BACKEND_URL}/host-commands`;
    const pool = {
      host_id,
      page,
      limit,
      filter,
      sort: '-created_at',
    };
    yield delay(LOADING_DELAY);
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK && responseJson) {
      yield put(loadHistoryListSuccessful(responseJson));
      yield call(resolveActionPromise(action, responseJson));
    } else {
      yield put(loadHistoryListFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(loadHistoryListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
